export const AVAILABLE_FACETS = ["people", "departments"] as const
